module.exports = __webpack_public_path__ + "static/top-b8a7c923a074f55567bc7cd55a2d6cd2.png";